import { last } from "rxjs";
import { User } from "../user.model";

export class Note {
  constructor(id?: number,
    abstractProtocolID?: number,
    notePlain?: string,
    noteHtml?: string,
    abstractStatusID?: number,
    parentNoteID?: number,
    evaluationID?: number,
    applicationUser?: User,
    lastModifiedDate?: Date) {

    this.abstractProtocolID = abstractProtocolID;
    this.noteHtml = noteHtml;
    this.notePlain = notePlain;
    this.abstractStatusID = abstractStatusID;
    this.parentNoteID = parentNoteID;
    this.id = id;
    this.evaluationID = evaluationID;
    this.applicationUser = applicationUser;
    this.lastModifiedDate = lastModifiedDate;
  }

  public id: number;
  public abstractProtocolID: number;
  public noteHtml: string;
  public notePlain: string;
  public abstractStatusID: number;
  public parentNoteID: number;
  public evaluationID: number;
  public applicationUser: User;
  public lastModifiedDate: Date;

}

